import React, { Component } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import mainRoutes from "../../routes/main";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { connect } from 'react-redux'
import { appName } from './../../actions'
import * as animationData from './../../assets/images/splash.json'
import * as animationDisconnect from './../../assets/images/disconnect.json'
import Lottie from 'react-lottie';
import { Tween } from 'react-gsap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import { checkInternet } from './../../utils/checkInternet'
import { hasInternet } from './../../actions'
import Footer from "../../components/Footer/Footer";
const RouteWithParams = ({ Component }) => {
    const params = useParams();
    return <Component params={params} />;
};

const switchRoutes = (
    <Routes>
        {mainRoutes.map((prop, key) => {
            const Component = prop.component;
            const hasParams = prop.path && prop.path.includes(":");
            return (
                <Route
                    path={prop.path}
                    element={hasParams ? <RouteWithParams Component={Component} /> : <Component />}
                    key={key}
                />
            );
        })}
    </Routes>
);

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            banner: false,
            hasInternet: false
        };

    }



    deferredPrompt;
    async componentDidMount() {

            window.addEventListener("beforeinstallprompt", e => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
            this.setState({ banner: true });
        });
        if (navigator.onLine) {
            this.setState({ hasInternet: false })
        } else {
            this.setState({ hasInternet: true })
        }
        console.log("hamed =>" , this.deferredPrompt);
    }

    getData = socket => {
        socket.on('header', data => {
            this.setState({ app_name: data.app_name });
            this.props.dispatch(appName(data.app_title, data.app_subtitle));
        })
        socket.emit("header", {});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.network) {
            this.setState({ hasInternet: true })
        } else {
            this.setState({ hasInternet: false })
        }
        nextProps.socket !== null ? this.getData(nextProps.socket) : console.log("not yet");
    }
    install = () => {
        this.setState({ banner: false });
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
        }
        this.deferredPrompt.userChoice.then(choiceResult => {
            if (choiceResult.outcome === "accepted") {
            } else {
            }
            this.deferredPrompt = null;
        });
        console.log("hamed =>" , this.deferredPrompt);
    }
    handleClose = () => {
        this.setState({ banner: false });
    }
    handleCheckInternet = () => {
        this.props.dispatch(hasInternet(checkInternet()))
    }
    render() {

        const collapseClass = (this.state.collapseClass ? 'collapsed-sidebar' : '');
        const { app_name, loading, banner, hasInternet } = this.state;
        const { style } = this.props;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData.default,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        const disconnectOptions = {
            loop: true,
            autoplay: true,
            animationData: animationDisconnect.default,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };


        return (
            <div className={`main-container ${style} ${localStorage.getItem("fontSize")}`}>
                <Tween
                    from={{ opacity: 1, display: "flex" }}
                    to={{ delay: 0, opacity: !loading ? "0" : "1", display: !loading ? "none" : "flex" }}
                    duration={1}
                >
                    <div className="splash">
                        <Lottie options={defaultOptions}
                            color="#ff0000"
                            className='animation'

                        />
                    </div>
                </Tween>
                <div className={`disconnected ${!hasInternet ? "active" : ""}`}>
                    <Lottie options={disconnectOptions}
                        color="#ff0000"
                        className='animation'
                        width="150"
                        height="150"
                    />
                    <span>ارتباط اینترنت شما قطع میباشد</span>
                    <RefreshIcon onClick={this.handleCheckInternet} />
                </div>
                <Header />
                <Sidebar app_name={app_name} />
                <main className={`main-content ${collapseClass}`}>
                    <div className="main-wrapper" app_name={app_name}>
                        {switchRoutes}
                    </div>
                </main>
                <Footer/>
                <Dialog
                    open={banner}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"نصب اپلیکیشن Silver House"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleClose} variant="contained" style={{ marginLeft: "10px" }}>
                            بازگشت
          </Button>
                        <Button onClick={this.install} variant="contained" color="primary">
                            نصب
          </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        style: state.styleMode,
        network: state.networkMode,
        socket: state.setSocket,
    }
}

export default connect(mapStateToProps)(Main)

